<!-- ── Associated EPEs panel ───────────────────────────────────────────────── -->
<div class="action-panel">
  <div class="action-panel-header">
    <i class="fa fa-handshake-o" style="margin-right:5px;"></i>Association
  </div>
  <div class="action-panel-body action-panel-body--list">

    <p *ngIf="getEpes().length === 0" class="action-panel-desc">
      No EPEs selected yet for this project.
    </p>

    <div *ngFor="let epe of getEpes(); let i = index">
      <association-epe
        *ngIf="expanded || i < 5"
        [project_association_status]="association_status"
        [epe]="epe">
      </association-epe>
    </div>

    <button *ngIf="getEpes().length > 5 &&
                   association_status !== 'selected' &&
                   association_status !== 'approved' &&
                   association_status !== 'completed' &&
                   association_status !== 'closed' &&
                   (!auth.isEpe() || auth.isCallManager() || auth.isProjectBoard() || auth.isAdmin()) &&
                   !auth.isProject()"
            id="showMoreButton{{ project_id }}"
            (click)="expanded = !expanded"
            class="btn btn-default action-btn action-btn--secondary" style="margin-top:8px;">
      {{ expanded ? 'Show less' : 'Show more (' + (getEpes().length - 5) + ' more)' }}
    </button>

  </div>
</div>

<!-- ── Actions panel ───────────────────────────────────────────────────────── -->
<div class="action-panel" style="margin-top: 10px;"
     *ngIf="(association_status !== 'selected' &&
             association_status !== 'approved' &&
             association_status !== 'completed' &&
             association_status !== 'closed' &&
             (!auth.isEpe() || auth.isCallManager() || auth.isProjectBoard() || auth.isAdmin()) &&
             !auth.isProject()) ||
            (auth.isEpe() && association_status === 'selected') ||
            (association_status === 'approved' || association_status === 'completed' || association_status === 'closed')">
  <div class="action-panel-header">Actions</div>
  <div class="action-panel-body">

    <!-- Submit association (admin / call manager / project board) -->
    <button *ngIf="association_status !== 'selected' &&
                   association_status !== 'approved' &&
                   association_status !== 'completed' &&
                   association_status !== 'closed' &&
                   (!auth.isEpe() || auth.isCallManager() || auth.isProjectBoard() || auth.isAdmin()) &&
                   !auth.isProject()"
            (click)="submitEligibility()"
            class="btn btn-primary action-btn">
      Submit Association
    </button>

    <!-- EPE accept / decline (EPE user + selected status) -->
    <ng-container *ngIf="auth.isEpe() && association_status === 'selected'">
      <button (click)="submitEpeResponse(true)" class="btn btn-success action-btn">
        Accept Association
      </button>
      <button (click)="submitEpeResponse(false)" class="btn btn-danger action-btn">
        Decline Association
      </button>
    </ng-container>

    <!-- Go to service / close service (approved / completed / closed) -->
    <ng-container *ngIf="association_status === 'approved' || association_status === 'completed' || association_status === 'closed'">
      <button (click)="goToMeetingForm()" class="btn btn-primary action-btn">
        Go to the Service
      </button>
      <button *ngIf="!auth.isProject() && !auth.isEpe() && association_status === 'completed'"
              (click)="closeService()"
              class="btn btn-default action-btn action-btn--secondary">
        Close the Service
      </button>
    </ng-container>

  </div>
</div>

<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
